exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".col-navbar[data-v-9c5a32ea]{flex:0 1 220px;max-width:220px}.col-navbar .nav-link[data-v-9c5a32ea]{font-size:.9375rem;white-space:normal!important}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/Calculators/CalculatorSidebar.vue"],"names":[],"mappings":"AACA,6BAA6B,eAAe,eAAe,CAC1D,AACD,uCAAuC,mBAAmB,4BAA8B,CACvF","file":"CalculatorSidebar.vue","sourcesContent":["\n.col-navbar[data-v-9c5a32ea]{flex:0 1 220px;max-width:220px\n}\n.col-navbar .nav-link[data-v-9c5a32ea]{font-size:.9375rem;white-space:initial !important\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9c5a32ea","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"quietDeps":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Calculators/CalculatorSidebar.vue
// module id = 1435
// module chunks = 21